import React from 'react';
import { connect } from 'react-redux';
import Header from '../layout/Header';
import Message from '../layout/Message';
import Button from '../layout/Button';
import FormField from '../layout/FormField';

import {
    fetchPianoTechPianoList,
    RETURN_TO_PIANOTECHPIANO_LIST,
    SWITCH_EDIT_TYPE,
    PIANOTECHPIANO_MODIFIED,
    SAVE_PIANOTECHPIANO_STARTED,
    savePianoTechPiano,
    PIANOTECHPIANO_VALIDATE,
} from '../../actions/PianoTechPianoActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_EDIT,
    MAINTENANCE_TYPE_ADD,
    MAINTENANCE_TYPE_COMPLETE,
    MAINTENANCE_TYPE_DELETE,
    uiFieldInfoPianoTechPiano,
    MESSAGE_TYPE_INFO,
    MESSAGE_TYPE_ERROR,
} from '../../app-constants';

import {
    validateForm,
    checkForChanges,
} from '../../utilities/validate';

const mapStateToProps = state => ({
    pianoTechPiano: state.pianoTechPiano,
    user: state.user,
});

class PianoTechPiano extends React.PureComponent {

    returnToList = () => {

        if (this.props.pianoTechPiano.maintenanceType === MAINTENANCE_TYPE_COMPLETE)
            this.props.dispatch(fetchPianoTechPianoList());

        this.props.dispatch({
            type: RETURN_TO_PIANOTECHPIANO_LIST
        })
    }

    onCancelClose = () => {

        switch (this.props.pianoTechPiano.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
            case MAINTENANCE_TYPE_EDIT: {
                //Back to View Mode - restore original 
                const pianoTechPiano = Object.assign({}, this.props.pianoTechPiano.originalPianoTechPiano);
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE,
                    maintenanceType: MAINTENANCE_TYPE_VIEW,
                    title: "View PianoTechPiano",
                    pianoTechPiano,
                });

                break;
            }

            default:
                this.returnToList();
        }
    }

    editPianoTechPiano = () => {
        const pianoTechPiano = this.props.pianoTechPiano.pianoTechPiano;
        this.props.dispatch({
            type: SWITCH_EDIT_TYPE,
            maintenanceType: MAINTENANCE_TYPE_EDIT,
            title: "Edit PianoTechPiano",
            pianoTechPiano,
        });
    }

    onDelete = () => {
        switch (this.props.pianoTechPiano.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                this.saveAction();
                break;

            default:
                const pianoTechPiano = this.props.pianoTechPiano.pianoTechPiano;
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE,
                    maintenanceType: MAINTENANCE_TYPE_DELETE,
                    title: "Delete PianoTechPiano",
                    pianoTechPiano,
                });
        }
    }

    saveAction = () => {
        let message = '';

        switch (this.props.pianoTechPiano.maintenanceType) {
            case MAINTENANCE_TYPE_EDIT:
                message = 'Saving PianoTechPiano';
                break;
            case MAINTENANCE_TYPE_DELETE:
                message = 'Deleting PianoTechPiano';
                break;
            case MAINTENANCE_TYPE_ADD:
                message = 'Adding PianoTechPiano';
                break;

            default:

        }

        this.props.dispatch({
            type: SAVE_PIANOTECHPIANO_STARTED,
            message,
        })

        const { pianoTechPiano } = this.props.pianoTechPiano;
        pianoTechPiano.maintenanceType = this.props.pianoTechPiano.maintenanceType;
        this.props.dispatch(savePianoTechPiano(pianoTechPiano));
    }

    onChange = (e) => {
        const fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (e.target.type === 'checkbox') {
            fieldValue = e.target.checked;
        }

        const { pianoTechPiano } = this.props.pianoTechPiano;
        pianoTechPiano[fieldName] = fieldValue;

        this.props.dispatch({
            type: PIANOTECHPIANO_MODIFIED,
            pianoTechPiano,
        })

    }

    formValid = () => {
        const { pianoTechPiano, maintenanceType } = this.props.pianoTechPiano;
        const validFormInfo = validateForm(uiFieldInfoPianoTechPiano, pianoTechPiano, maintenanceType);

        return validFormInfo.valid;
    }

    validate = () => {
        const { pianoTechPiano, maintenanceType } = this.props.pianoTechPiano;
        const validInfo = validateForm(uiFieldInfoPianoTechPiano, pianoTechPiano, maintenanceType);

        let message = '';
        let messageType = MESSAGE_TYPE_ERROR;

        if (validInfo.errors.length > 0) {
            validInfo.errors.map((err) => {
                message += err;
                return '';
            });
        } else {
            messageType = MESSAGE_TYPE_INFO;
            validInfo.info.map((info) => {
                message += info;
                return '';
            });
        }

        this.props.dispatch({
            type: PIANOTECHPIANO_VALIDATE,
            message,
            messageType,
        })
    }

    checkForChanges = () => {
        const { pianoTechPiano, originalPianoTechPiano, maintenanceType } = this.props.pianoTechPiano

        if (!this.formValid())
            return false;

        if (maintenanceType === 'add') {
            return true;
        }

        return checkForChanges(uiFieldInfoPianoTechPiano, pianoTechPiano, originalPianoTechPiano)

    }

    render() {
        const { pianoTechPiano } = this.props.pianoTechPiano;
        const { adminUser, simulatingUser } = this.props.user;

        let showSave = false, showDelete = false, cancelCloseText = 'Cancel', showEdit = false,
            disabled = false, disableSave = false, deleteText = 'Delete';

        switch (this.props.pianoTechPiano.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                showDelete = true;
                disabled = true;
                deleteText = 'Confirm Delete';
                break;

            case MAINTENANCE_TYPE_COMPLETE:
                showSave = false;
                cancelCloseText = 'Close';
                disabled = true;
                break;

            case MAINTENANCE_TYPE_VIEW:
                showEdit = this.props.user.allowEdit;
                showDelete = this.props.user.allowDelete;
                disabled = true;
                cancelCloseText = 'Close';
                break;

            default:
                if (this.props.user.allowEdit)
                    showSave = true;

                disableSave = !this.checkForChanges();
        }

        return (
            <div className="divMedium" align="center">
                <Header header2={this.props.pianoTechPiano.title} />
                <Message message={this.props.pianoTechPiano.message}
                    type={this.props.pianoTechPiano.messageType} />
                <br />
                <table className='tableMedium'>
                    <tbody>
                        <tr>
                            <td>
                                <Button className="bluebutton" description="Return to List" onClick={this.returnToList} />
                            </td>
                            <td>
                            </td>
                        </tr>
                        {this.props.pianoTechPiano.maintenanceType !== 'add' &&
                            <FormField row form={{ title: 'Piano Id', type: 'textinput', length: '10', maxLength: '10', disabled: true }}
                                name="pianoId"
                                value={pianoTechPiano.pianoId}
                                onChange={this.onChange}
                            />
                        }
                        {adminUser && !simulatingUser &&
                            <React.Fragment>
                                <FormField row form={{ title: 'Company Id', type: 'textinput', length: '10', maxLength: '10', disabled }}
                                    name="companyId"
                                    value={pianoTechPiano.companyId}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Customer Id', type: 'textinput', length: '10', maxLength: '10', disabled }}
                                    name="customerId"
                                    value={pianoTechPiano.customerId}
                                    onChange={this.onChange}
                                />
                            </React.Fragment>
                        }
                        <FormField row form={{ title: 'Device Type', type: 'textinput', length: '50', maxLength: '50', disabled }}
                            name="deviceType"
                            value={pianoTechPiano.deviceType}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Year', type: 'textinput', length: '20', maxLength: '20', disabled }}
                            name="year"
                            value={pianoTechPiano.year}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Make', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="make"
                            value={pianoTechPiano.make}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Model', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="model"
                            value={pianoTechPiano.model}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'SerialNumber', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="serialNumber"
                            value={pianoTechPiano.serialNumber}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Nickname', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="nickname"
                            value={pianoTechPiano.nickname}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'DefaultMinutesPerAppointment', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="defaultMinutesPerAppointment"
                            value={pianoTechPiano.defaultMinutesPerAppointment}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Notes', type: 'textinput', length: '5000', maxLength: '5000', disabled }}
                            name="notes"
                            value={pianoTechPiano.notes}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Normal Months Between Tunnings', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="normalMonthsBetweenTunnings"
                            value={pianoTechPiano.normalMonthsBetweenTunnings}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Last Piano Tune', type: 'datetime', length: '19', maxLength: '19', disabled }}
                            name="lastPianoTune"
                            value={pianoTechPiano.lastPianoTune}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Created', type: 'textinput', length: '19', maxLength: '19', disabled: true }}
                            name="created"
                            value={pianoTechPiano.created}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Last Updated', type: 'textinput', length: '19', maxLength: '19', disabled: true }}
                            name="lastUpdated"
                            value={pianoTechPiano.lastUpdated}
                            onChange={this.onChange}
                        />
                        <tr>
                            <td>
                                {showEdit &&
                                    <Button className="bluebutton" description="Edit" onClick={this.editPianoTechPiano} />
                                }
                                {showDelete &&
                                    <Button className="bluebutton" description={deleteText} onClick={this.onDelete} />
                                }
                                {showSave &&
                                    <div>
                                        <Button className="bluebutton" description="Save" disabled={disableSave} onClick={this.saveAction} />
                                        <Button className="bluebutton" description="Validate" onClick={this.validate} />
                                    </div>
                                }
                            </td>
                            <td>
                                <Button className="bluebutton" description={cancelCloseText} onClick={this.onCancelClose} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

}

export default connect(mapStateToProps)(PianoTechPiano);
